import { Button, Modal } from 'react-bootstrap';
import { Dispatch, SetStateAction, useCallback, useState } from 'react';
import { useAppSelector } from '../../../../../redux/store';
import DataTable from 'react-data-table-component';
import CustomLoader from '../../../../data/customLoader';
import { IoIosAddCircle } from 'react-icons/io';
import { paginationOptions } from '../../../../data/PagineteInfo';
import { notify, notifyError } from '../../../../notify/notify-component';
import { Section } from '../../Complements/ModalAdd/styled';
import tableStyleDefaul from '../../../../../Services/tableStyleDefault';
import { InputDefault } from '../../../../data/inputDefault';
import { useProductsQuery } from '../../../../../apiQuery/useProductsQuery';

interface IProps {
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  setAssociatedComplement: Dispatch<SetStateAction<any[]>>;
  associatedComplement: any;
}

export default function ModalADD({
  show,
  setShow,
  associatedComplement,
  setAssociatedComplement,
}: IProps) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [clearRows, setClearRows] = useState<boolean>(false);
  const [addInBuçk, setAddInBulk] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [name, setName] = useState<string>();
  const [page, setPage] = useState(1);

  const {
    data: productsList,
    isLoading,
    isError,
  } = useProductsQuery(storeMe?.storeActive?.id, page, name);

  const columns: any = [
    {
      name: 'Código',
      sortable: true,
      width: '100px',
      center: true,
      selector: (row: any) => row?.id_pdv,
    },
    {
      name: 'Produto',
      minWidth: '190px',
      sortable: true,
      selector: (row: any) => row.sale_name?.toLowerCase(),
    },
    {
      name: 'Adicionar',
      cell: (row: any) => (
        <div className="actions">
          <IoIosAddCircle
            size={20}
            data-toggle="tooltip"
            data-placement="top"
            title="Adicionar"
            className="action"
            onClick={() => handleAdd(row)}
            style={{ marginRight: 16 }}
            color="#3C7EDF"
          />
        </div>
      ),
      button: true,
    },
  ];

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const handlePerRowsChange = (newPerPage: number, page: number) => {
    //setPerPage(newPerPage);
    setPage(page);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedRows([]);
  };

  const handleAdd = (complement: any) => {
    const alreadyExists = associatedComplement?.find(
      (item: any) => item?.id === complement?.id
    );

    if (alreadyExists) {
      notify('Associado já adicionado.');
      return;
    }
    setAssociatedComplement((prevent: any = []) => [
      ...(Array.isArray(prevent) ? prevent : []),
      complement,
    ]);
  };

  const handleRowsChange = useCallback((state: any) => {
    setSelectedRows(state.selectedRows);
    setClearRows(false);

    if (state.selectedRows.length > 0) {
      setAddInBulk(true);
    }
  }, []);

  const handleAddInBulk = () => {
    if (associatedComplement?.length > 0) {
      for (let index = 0; index < selectedRows?.length; index++) {
        const alreadyExists = associatedComplement?.find(
          (item: any) => item?.id === selectedRows[index]?.id
        );

        if (alreadyExists) {
          return;
        } else {
          setAssociatedComplement((prevent: any) => [
            ...prevent,
            selectedRows[index],
          ]);
          handleClose();
        }
      }
    } else {
      setAssociatedComplement(selectedRows);
      handleClose();
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      style={{ fontSize: '12px' }}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h3>Adicionar extras</h3>
        </Modal.Title>
      </Modal.Header>
      <div>
        <Modal.Body>
          <Section>
            <InputDefault
              label="Produto"
              placeholder="Produto"
              type="text"
              state={name}
              setState={setName}
            />
          </Section>
          <DataTable
            columns={columns}
            data={productsList?.data || []}
            striped
            onSelectedRowsChange={handleRowsChange}
            clearSelectedRows={clearRows}
            selectableRows
            pagination
            paginationServer
            paginationTotalRows={productsList?.meta?.total}
            paginationDefaultPage={1}
            paginationPerPage={productsList?.meta?.per_page}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
            customStyles={tableStyleDefaul}
            paginationComponentOptions={paginationOptions}
            progressPending={isLoading}
            progressComponent={<CustomLoader />}
            noDataComponent="Nenhuma informação foi encontrada."
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Fechar
          </Button>
          {selectedRows?.length > 0 && (
            <Button variant="primary" onClick={handleAddInBulk}>
              Salvar
            </Button>
          )}
        </Modal.Footer>
      </div>
    </Modal>
  );
}
